import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaPinterestP,
  FaTiktok,
  FaYoutube,
} from "react-icons/fa";
import { FaSquareXTwitter } from "react-icons/fa6";

import classes from "./SocialSection.module.css";

const socialLinks = [
  {
    href: "https://www.facebook.com/psprcm/",
    label: "Facebook",
    icon: <FaFacebookF />,
  },
  {
    href: "https://www.instagram.com/psprcmus/",
    label: "Instagram",
    icon: <FaInstagram />,
  },
  {
    href: "https://www.pinterest.com/psprcmus/",
    label: "Pinterest",
    icon: <FaPinterestP />,
  },
  {
    href: "https://www.x.com/psprcmus/",
    label: "X",
    icon: <FaSquareXTwitter />,
  },
  {
    href: "https://www.linkedin.com/company/psprcmus/",
    label: "LinkedIn",
    icon: <FaLinkedinIn />,
  },
  {
    href: "https://www.tiktok.com/@psprcmus",
    label: "TikTok",
    icon: <FaTiktok />,
  },
  {
    href: "https://www.youtube.com/@psprcmus",
    label: "YouTube",
    icon: <FaYoutube />,
  },
];

export default function SocialSection() {
  return (
    <div className={classes.socialIcons}>
      {socialLinks.map((item) => (
        <a
          key={item.label}
          href={item.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={item.label}
        >
          {item.icon}
        </a>
      ))}
    </div>
  );
}
